import { useEditorStore } from "@/zapi-frontend/stores/editor";
import { useEffect } from "react";
import { isTableRow, stripMarkdown } from "./stripMarkdown";
import { useMediaQuery } from "@/zapi-frontend/shared/hooks/useMediaQuery";

export function useHighlightClaim({ claimMarkdown }: { claimMarkdown: string | undefined }) {
  const { highlightText, highlightTableRow } = useEditorStore();

  const isMobile = useMediaQuery("(max-width: 984px)");

  const focusClaim = () => {
    if (isMobile) return;

    if (claimMarkdown) {
      const isTable = isTableRow(claimMarkdown);
      const cleanText = stripMarkdown(claimMarkdown);

      if (isTable && highlightTableRow) {
        highlightTableRow(claimMarkdown, cleanText);
      } else if (highlightText) {
        highlightText(cleanText);
      }
    }
  };

  useEffect(() => {
    focusClaim();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [claimMarkdown, highlightText, highlightTableRow, isMobile]);

  return { focusClaim };
}
